/// <reference path="jquery.d.ts" />
export default class VideoController {
    selectors : any;

    constructor () {
        this.selectors = {};
        this.selectors.video_button = '#video-control';
        this.init();
    }
    init () {
        var video_button = $(this.selectors.video_button);
        video_button.addClass('pause');
        video_button.on('click', function(){
            var e = $(this);
            if (e.hasClass('pause')) {
                e.addClass('play');
                e.removeClass('pause');
                $('video').get(0).pause();
            } else {
                e.addClass('pause');
                e.removeClass('play');
                $('video').get(0).play();
            }
        });
    }
}